// @ts-nocheck
import { BlockVariantOption, BlockVariantOptions } from "@store/Library/Components/Toolkit/Block/variant/base";
import alternative, {
    BlockVariantAlternativeProps,
} from "@store/Library/Components/Toolkit/Block/variant/types/alternative";
import background, {
    BlockVariantBackgroundProps,
} from "@store/Library/Components/Toolkit/Block/variant/types/background";
import bordered, { BlockVariantBorderedProps } from "@store/Library/Components/Toolkit/Block/variant/types/bordered";
import separated, {
    BlockVariantSeparatedProps,
} from "@store/Library/Components/Toolkit/Block/variant/types/separated";

export interface BlockVariantOptionMapper {
    alternative: BlockVariantOption<BlockVariantAlternativeProps>;
    background: BlockVariantOption<BlockVariantBackgroundProps>;
    bordered: BlockVariantOption<BlockVariantBorderedProps>;
    separated: BlockVariantOption<BlockVariantSeparatedProps>;
}

export const blockVariantOptions: BlockVariantOptions = {
    alternative: { id: "Alternative", displayName: "Alternative", type: alternative },
    background: { id: "Background", displayName: "Background", type: background, hidden: true },
    bordered: { id: "Bordered", displayName: "Bordered", type: bordered, hasSideVariant: true },
    separated: { id: "Separated", displayName: "Separated", type: separated, hasSideVariant: true },
};
